let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lSIud")).then(() => parcelRequire('1iOv0'));